/**
 * Quiz handling
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';


injector.injectClass(class extends Script {
    onLoad() {
        const selector = '.quiz-wrapper input:button';
        $('body').on('click', selector, this.$wrap(this.handleClick));
    }

    handleClick($this) {
        const $parent = $this.closest('.quiz-wrapper');
        let $new = $this.data('new');
        if ($new) {
            $this.removeData('new');
            $this.val('Get Answers');
            $new.remove();
        }
        else {
            $new = $parent.clone();

            $new.find('input:button').remove();

            const answers = this.getAnswers($this[0].onclick.toString());
            $new.find('input').each(function (i) {
                const $this = $(this);
                if (answers.length > i) $this.val(answers[i]);
                $this.prop('readonly', true)
                     .removeClass('quiz-item-incorrect')
                     .addClass('quiz-item-correct')
                     .attr('size', answers[i].length);
            });

            $new.insertAfter($parent);

            $this.data('new', $new);
            $this.val('Hide Answers');
        }
    }

    getAnswers(func) {
        let answers = [];

        func = func.match(/\((.*)\);/);
        if (func && func.length > 0) {
            answers = func[1].replace(/^['\s]+|['\s]+$/g, '').split(/(?:\\n)+/);
        }

        let ascending = true;
        for (let i = 0; i < answers.length; ++i) {
            const num = +answers[i].trim().replace(/^(\d+).*/, '$1');
            if (num !== i + 1) {
                ascending = false;
                break;
            }
        }

        const result = [];
        for (let i = 0; i < answers.length; ++i) {
            if (ascending) answers[i] = answers[i].replace(/^\d+[\s.-]+/, '');
            else answers[i] = answers[i].replace(/^[\s.-]+/, '');
            const answer = answers[i].split(/\//);
            for (let j = 0; j < answer.length; ++j) {
                result.push(answer[j].trim().replace(/\\+'/g, "'"));
            }
        }

        return result;
    }
});
